import * as yup from 'yup';

import {
  requiredBirthdateField,
  requiredSelectField,
  requiredStringField,
} from '@blockpulse3/web-client/forms';

import { IUpdateProfileForm } from './types';

export const schema = yup
  .object({
    firstName: requiredStringField,
    lastName: requiredStringField,
    birthdate: requiredBirthdateField,
    birthplace: requiredStringField,
    nationality: requiredSelectField,
    gender: requiredStringField,
  })
  .required() as yup.ObjectSchema<IUpdateProfileForm>;

export const profileDefaultValues: IUpdateProfileForm = {
  profilePicture: '',
  firstName: '',
  lastName: '',
  birthdate: '',
  birthplace: '',
  nationality: { label: '', value: '' },
  gender: '',
};
